import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.061 8.89577L15.9814 12.1728L13.1403 14.1074L12.2199 10.8304L15.061 8.89577ZM6.09744 5.71747L5.43717 6.03332C5.02368 6.20441 4.74356 6.49711 4.59684 6.9114C4.45011 7.3257 4.47012 7.7371 4.65686 8.14561L6.09744 11.2252V5.71747ZM9.29872 4C8.85854 4 8.48186 4.15793 8.16867 4.47378C7.85547 4.78964 7.69861 5.16472 7.69808 5.59902V10.3171L9.83894 4.51327C9.87895 4.42114 9.9123 4.33218 9.93898 4.24637C9.96565 4.16056 10.0123 4.07844 10.079 4H9.29872ZM13.4204 4.09871C13.0069 3.95394 12.5934 3.97368 12.1799 4.15793C11.7664 4.34218 11.4863 4.63829 11.3395 5.04627L7.79812 14.6996C7.65139 15.1076 7.6714 15.5124 7.85814 15.9141C8.04488 16.3158 8.345 16.5887 8.7585 16.7329L14.7809 18.9045C15.1944 19.0492 15.6047 19.0295 16.0118 18.8452C16.4189 18.661 16.6955 18.3649 16.8417 17.9569L20.4032 8.30354C20.5499 7.89556 20.5299 7.49074 20.3431 7.08907C20.1564 6.68741 19.8563 6.41446 19.4428 6.27022L13.4204 4.09871Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }